<template>
  <TransitionGroup
    tag="div"
    name="layer-card"
    class="layer-pannel flex gap-2 absolute right-10 bottom-3"
  >
    <div
      class="layer-card overflow-hidden border-white border-2 shadow-md rounded-lg relative"
      :class="layer.visible ? 'border-blue-500' : 'border-white'"
      v-for="layer in layers.filter((l) => isSelecting || l.visible)"
      :key="layer.key"
      @click="selectLayer(layer)"
    >
      <img :src="layer.icon" alt="" srcset="" />
      <span class="absolute right-0 bottom-0 bg-blue-500 text-white text-xs px-2 py-1">{{
        layer.name
      }}</span>
    </div>
  </TransitionGroup>
</template>
<script setup lang="ts">
import { ref } from 'vue'
import shiproadUrl from '@/assets/shiproad.png'
import tdtImgUrl from '@/assets/tdtImg.png'
import tdtVecUrl from '@/assets/tdtVec.png'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import { BASELAYERS } from '@/components/GIS'

interface layerCfg {
  name: string
  key: BASELAYERS
  icon: string
  visible: boolean
}
const isSelecting = ref(false)
const selectLayer = async (layer: layerCfg) => {
  if (!isSelecting.value) {
    isSelecting.value = true
    return
  }
  const cesiumobj = await CesiumObj.getInstance()
  layers.value.forEach((l) => {
    if (l.name == layer.name) {
      if (l.visible == false) {
        l.visible = true
        cesiumobj.baselayerSelector.setBaseLayer(layer.key)
      }
    } else l.visible = false
  })
  isSelecting.value = false
}
const layers = ref<layerCfg[]>([
  {
    name: '航道图',
    key: BASELAYERS.S57,
    icon: shiproadUrl,
    visible: false,
  },
  {
    name: '卫星图',
    key: BASELAYERS.IMG,
    icon: tdtImgUrl,
    visible: true,
  },
  {
    name: '矢量图',
    key: BASELAYERS.VEC,
    icon: tdtVecUrl,
    visible: false,
  },
])
</script>
<style lang="scss" scoped>
.layer-pannel {
  .layer-card {
    width: 200px;
    height: 120px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.layer-card-move,
.layer-card-enter-active,
.layer-card-leave-active {
  transition: all 0.5s ease;
}
.layer-card-enter-from,
.layer-card-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.layer-card-leave-active {
  position: absolute;
}
</style>
